import "./style.css";

function Label({ children, required, className }) {
    return <div className={`label ${className}`}>{children}{required && <span style={{ color: "red"}}>*</span>}</div>
}

export default Label;